import React from 'react';
/**
 * Calls the given `onProvideFormApi` callback to provide access to the
 * current form state to the outside of the form itsself
 *
 * @param payload option back containing the provider callback and the
 * current form state
 */
export function useProvideStatFormApi({ onProvideFormApi, formState: { isValid, isDirty, isSubmitting }, reset, }) {
    const isValidCb = React.useCallback(() => isValid, [isValid]);
    const isDirtyCb = React.useCallback(() => isDirty, [isDirty]);
    const isSubmittingCb = React.useCallback(() => isSubmitting, [isSubmitting]);
    const onFormStateChanged = React.useEffectEvent((api) => {
        onProvideFormApi === null || onProvideFormApi === void 0 ? void 0 : onProvideFormApi({ ...api, reset });
    });
    React.useEffect(() => {
        onFormStateChanged({
            isValid: isValidCb,
            isDirty: isDirtyCb,
            isSubmitting: isSubmittingCb,
        });
    }, [isValidCb, isDirtyCb, isSubmittingCb]);
}
